import { render, staticRenderFns } from "./UserService.vue?vue&type=template&id=d01b9560&scoped=true&"
import script from "./UserService.vue?vue&type=script&lang=js&"
export * from "./UserService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01b9560",
  null
  
)

export default component.exports